import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ConfigurableUi } from '../../configurable-ui';
import { Switch } from './va-switch';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'va-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: flex;
        align-items: flex-start;
      }
    `,
  ],
  template: `
    <mat-slide-toggle
      #toggle
      [disabled]="config.disabled"
      [checked]="config.checked"
      [color]="config.color"
      (change)="config.onClick($event.checked)"
    >
      {{ toggle.checked ? 'On' : 'Off' }}
    </mat-slide-toggle>
  `,
  imports: [CommonModule, MatSlideToggleModule],
})
export class VaSwitchComponent implements ConfigurableUi {
  @Input() config: Switch;
}
